import { render, staticRenderFns } from "./use-terms.vue?vue&type=template&id=97248a3c&scoped=true&"
import script from "./use-terms.vue?vue&type=script&lang=js&"
export * from "./use-terms.vue?vue&type=script&lang=js&"
import style0 from "./use-terms.vue?vue&type=style&index=0&id=97248a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97248a3c",
  null
  
)

export default component.exports